module.exports = __webpack_public_path__ + "img/svgdefs-2_copy.50548013.svg";